import { Projection } from "types/types";

export const projections: Projection[] = [
  {
    id: 1,
    label: "EPSG:31370",
    url: "http://www.opengis.net/def/crs/EPSG/0/31370",
  },
];
